// "Color by" menu (iOS MapColorizeChip / the territory detail's "Colorize pins" picker): one checked entry per
// MapColorize in the iOS order. Used by the Map toolbar and the territory detail map.

import { ChevronDown, Palette } from 'lucide-react';
import { MAP_COLORIZES, MAP_COLORIZE_TITLES, type MapColorize } from '@/contracts/enums';
import { Button, DropdownMenu, type ButtonSize } from '@/ui';

export interface ColorByMenuProps {
  value: MapColorize;
  onChange: (mode: MapColorize) => void;
  /** The company default (`settings.defaultMapColorize`), marked "Default" in the menu. */
  defaultMode?: MapColorize;
  size?: ButtonSize;
  /** Drop the visible "Color by:" prefix below the `sm` breakpoint (the map toolbar on a phone). */
  compact?: boolean;
  className?: string;
}

export function ColorByMenu({ value, onChange, defaultMode, size = 'sm', compact = false, className }: ColorByMenuProps) {
  return (
    <DropdownMenu
      label="Color pins by"
      placement="bottom-end"
      minWidth={220}
      className={className}
      items={MAP_COLORIZES.map((mode) => ({
        id: mode,
        label: MAP_COLORIZE_TITLES[mode],
        description: mode === defaultMode ? 'Company default' : undefined,
        checked: mode === value,
        onSelect: () => onChange(mode),
      }))}
      trigger={
        <Button variant="secondary" size={size} icon={<Palette aria-hidden />} iconRight={<ChevronDown aria-hidden />}>
          <span className="sr-only">Color pins by: </span>
          <span aria-hidden className={compact ? 'max-sm:hidden' : undefined}>
            Color by:{' '}
          </span>
          {MAP_COLORIZE_TITLES[value]}
        </Button>
      }
    />
  );
}
